import React from 'react';

import SummaryCard from '@components/cards/summaries/hotel/SummaryCard';
import { formatArrayToString, getRoomInformations } from '@utils/utils';
import {
  FlightViewModel,
  HotelDetailFeatureCategoryViewModel,
  HotelDetailViewModel,
  PackageHotelDetailViewModel,
  PackageTransferViewModel,
  RoomLowestPriceViewModel,
  UserViewModel,
} from '@api/v3';

const PackageSummaryCard = ({
  data,
  shouldResearchPackage,
  onlyHotelData,
  flightData,
  tesisFeature,
  transferData,
  updatedLowestPrice,
  userInfo,
  handleNavigateRooms,
  ClickTripAdvisor,
  toggleMap,
  handleNavigateAboutUs,
  room,
  startDate,
  endDate,
  showKocAilem,
  toggleInstallments,
  timeRemaining,
}: {
  data?: PackageHotelDetailViewModel;
  shouldResearchPackage?: boolean;
  onlyHotelData?: HotelDetailViewModel;
  flightData: FlightViewModel[];
  tesisFeature?: HotelDetailFeatureCategoryViewModel;
  transferData: PackageTransferViewModel[];
  updatedLowestPrice?: RoomLowestPriceViewModel;
  userInfo: UserViewModel;
  handleNavigateRooms: () => void;
  ClickTripAdvisor: () => void;
  toggleMap: () => void;
  handleNavigateAboutUs: () => void;
  room: string | string[];
  startDate?: string | string[];
  endDate?: string | string[];
  showKocAilem: boolean;
  toggleInstallments: () => void;
  timeRemaining: any;
}) => {
  return data ? (
    <SummaryCard
      isBadge={tesisFeature?.features?.some(
        (item) => item.name === 'Misafirler Öneriyor' && item.badge
      )}
      cityId={data?.cityId}
      badge={data?.features}
      name={data?.name ?? ''}
      description={data?.description ?? ''}
      boardType={data?.boardType ?? ''}
      city={data?.city ?? ''}
      country={data?.country ?? ''}
      features={data?.mainFacilities}
      countryCode={data?.countryCode}
      prices={
        transferData
          ? shouldResearchPackage
            ? undefined
            : data?.nightCount &&
              data?.rooms?.length &&
              flightData &&
              transferData
            ? updatedLowestPrice
            : data?.lowestPrice
          : undefined
      }
      isExpedia={data?.isExpedia}
      isDomestic={data?.isDomestic}
      userInfo={userInfo}
      longitude={data?.longitude}
      latitude={data?.latitude}
      onNavigate={handleNavigateRooms}
      onClickTripAdvisor={ClickTripAdvisor}
      toggleMap={toggleMap}
      onReadMore={handleNavigateAboutUs}
      promotions={data?.promotions}
      installments={data?.bankInstallments}
      roomInformation={
        getRoomInformations(
          formatArrayToString(room),
          formatArrayToString(startDate || []),
          formatArrayToString(endDate || [])
        ).message
      }
      bankInstallMentForWorld={data?.maxInstallmentForWorld}
      showKocAilem={showKocAilem}
      showInstallments={toggleInstallments}
      hotelId={data?.id}
      imageUrl={data?.images?.[0]?.url ?? ''}
      //distanceFromCenter={data?.distanceFromCenter}
      // status={
      //   data?.rooms?.[0]?.details?.[0]?.informations?.[0]
      //     ?.availabilityStatus
      // }
      ispackage={true}
      timeRemaining={timeRemaining}
    />
  ) : (
    <SummaryCard
      countryCode={onlyHotelData?.countryCode}
      isBadge={tesisFeature?.features?.some(
        (item) => item.name === 'Misafirler Öneriyor' && item.badge
      )}
      cityId={onlyHotelData?.cityId}
      badge={onlyHotelData?.features}
      name={onlyHotelData?.name ?? ''}
      description={onlyHotelData?.description ?? ''}
      boardType={onlyHotelData?.boardType ?? ''}
      city={onlyHotelData?.city ?? ''}
      country={onlyHotelData?.country ?? ''}
      features={onlyHotelData?.mainFacilities}
      prices={
        transferData
          ? shouldResearchPackage
            ? undefined
            : onlyHotelData?.nightCount &&
              onlyHotelData?.rooms?.length &&
              flightData &&
              transferData
            ? updatedLowestPrice
            : onlyHotelData?.lowestPrice
          : undefined
      }
      isExpedia={onlyHotelData?.isExpedia}
      isDomestic={onlyHotelData?.isDomestic}
      userInfo={userInfo}
      longitude={onlyHotelData?.longitude}
      latitude={onlyHotelData?.latitude}
      onNavigate={handleNavigateRooms}
      onClickTripAdvisor={ClickTripAdvisor}
      toggleMap={toggleMap}
      onReadMore={handleNavigateAboutUs}
      promotions={onlyHotelData?.promotions}
      installments={onlyHotelData?.bankInstallments}
      roomInformation={
        getRoomInformations(
          formatArrayToString(room),
          formatArrayToString(startDate || []),
          formatArrayToString(endDate || [])
        ).message
      }
      bankInstallMentForWorld={onlyHotelData?.maxInstallmentForWorld}
      showKocAilem={showKocAilem}
      showInstallments={toggleInstallments}
      hotelId={onlyHotelData?.id}
      imageUrl={onlyHotelData?.images?.[0]?.url ?? ''}
      ispackage={true}
      //distanceFromCenter={data?.distanceFromCenter}
      // status={
      //   data?.rooms?.[0]?.details?.[0]?.informations?.[0]
      //     ?.availabilityStatus
      // }
    />
  );
};

export default PackageSummaryCard;
